<template>
  <div style="height: 100%; width: 100%">
    <q-table
      v-if="selection == 'multiple'"
      ref="table"
      style="width: 100%"
      :data="data"
      :columns="columns.filter(c => !c.hide)"
      :separator="separator"
      :rows-per-page-options="[0]"
      :pagination.sync="pagination"
      :flat="flat"
      :grid="grid"
      :filter="filter"
      :filter-method="customFilter"
      :virtual-scroll="vScroll"
      :row-key="rowKey"
      @row-click="handleClick"
      @row-dblclick="handleDoubleClick"
      :selected.sync="selected"
      :selection="selection"
      @selection="onSelection"
      :hide-pagination="hidePagination"
      :class="{
        sticky: sticky,
        darkDataTable: $q.dark.isActive
      }"
    >
      <template
        v-for="column in columns"
        v-slot:[`body-cell-${column.name}`]="props"
      >
        <slot :name="`body-cell-${column.name}`" v-bind:props="props">
          <q-td :props="props">
            {{ props.value }}
          </q-td>
        </slot>
      </template>
    </q-table>
    <q-table
      v-else
      ref="table"
      style="width: 100%"
      :data="data"
      :columns="columns.filter(c => !c.hide)"
      :separator="separator"
      :rows-per-page-options="[0]"
      :pagination.sync="pagination"
      :flat="flat"
      :grid="grid"
      :filter="filter"
      :filter-method="customFilter"
      :virtual-scroll="vScroll"
      :row-key="rowKey"
      @row-click="handleClick"
      @row-dblclick="handleDoubleClick"
      :selected.sync="selected"
      :hide-pagination="hidePagination"
      :class="{
        sticky: sticky,
        darkDataTable: $q.dark.isActive
      }"
    >
      <template
        v-for="column in columns"
        v-slot:[`body-cell-${column.name}`]="props"
      >
        <slot :name="`body-cell-${column.name}`" v-bind:props="props">
          <q-td :props="props">
            {{ props.value }}
          </q-td>
        </slot>
      </template>
    </q-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  computed: {
    ...mapGetters([])
  },
  props: {
    columns: Array,
    data: Array,
    vScroll: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    separator: {
      type: String,
      default: "horizontal"
    },
    sticky: {
      type: Boolean,
      default: true
    },
    grid: {
      type: Boolean,
      default: false
    },
    filter: {
      default: ""
    },
    externalFilter: {
      type: Function
    },
    selection: {
      type: String,
      default: "single"
    },
    rowKey: {
      type: String,
      default: "id"
    },
    disableSearchCols: {
      default: null
    },
    hidePagination: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  data: () => ({
    pagination: {
      rowsPerPage: 0
    },
    selected: [],
    lastIndex: null
  }),
  mounted() {},
  methods: {
    handleClick(evt, row, index) {
      // console.log(evt);
      // if (
      //   !evt.path[0].className.includes("q-btn") &&
      //   !evt.path[1].className.includes("q-btn")
      // ) {
      this.selected = [row];
      this.$emit("rowSelected", row);
      // }
    },
    handleDoubleClick(evt, row, index) {
      this.$emit("rowDoubleClick", row);
    },
    customFilter(rows, terms, cols) {
      // If terms is a straight string then search as normal Otherwise use externalFilter()
      if (typeof terms == "string") {
        console.log("test");
        console.log(rows);
        return rows.filter(row => {
          let matchFound = false;
          for (const col in row) {
            if (
              !this.disableSearchCols ||
              !this.disableSearchCols.includes(col)
            ) {
              let val = `${row[col]}`.toLowerCase();
              matchFound = val.toLowerCase().indexOf(terms.toLowerCase()) > -1;
              if (matchFound == true) {
                break;
              }
            }
          }
          return matchFound;
        });
      } else {
        // External Filter is sent through as a Property
        return this.externalFilter(rows, terms, cols);
      }
    },
    onSelection({ rows, added, evt }) {
      if (rows.length === 0 || this.$refs.table === void 0) {
        return;
      }

      const row = rows[0];
      const filteredSortedRows = this.$refs.table.filteredSortedRows;
      const rowIndex = filteredSortedRows.indexOf(row);
      const lastIndex = this.lastIndex;

      this.lastIndex = rowIndex;
      document.getSelection().removeAllRanges();

      if (this.$q.platform.is.mobile === true) {
        evt = { ctrlKey: true };
      } else if (
        evt !== Object(evt) ||
        (evt.shiftKey !== true && evt.ctrlKey !== true)
      ) {
        this.selected = added === true ? rows : [];

        return;
      }

      const operateSelection =
        added === true
          ? selRow => {
              const selectedIndex = this.selected.indexOf(selRow);
              if (selectedIndex === -1) {
                this.selected = this.selected.concat(selRow);
              }
            }
          : selRow => {
              const selectedIndex = this.selected.indexOf(selRow);
              if (selectedIndex > -1) {
                this.selected = this.selected
                  .slice(0, selectedIndex)
                  .concat(this.selected.slice(selectedIndex + 1));
              }
            };
      if (lastIndex === null || evt.shiftKey !== true) {
        operateSelection(row);

        return;
      }
      const from = lastIndex < rowIndex ? lastIndex : rowIndex;
      const to = lastIndex < rowIndex ? rowIndex : lastIndex;

      for (let i = from; i <= to; i += 1) {
        operateSelection(filteredSortedRows[i]);
      }
      let test = JSON.parse(JSON.stringify(this.selected));
      setTimeout(() => {
        this.selected = test;
      }, 50);
    }
  }
};
</script>

<style lang="scss">
.sticky {
  height: 100% !important;

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    /* bg color is important for th; just specify one */
    background-color: white;
  }

  thead tr th {
    position: sticky;
    z-index: 1;
  }

  thead tr:first-child th {
    top: 0;
  }

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th {
    top: 48px;
    /* height of all previous header rows */
  }
}

.darkDataTable {
  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    /* bg color is important for th; just specify one */
    background-color: $accent !important;
  }
}
</style>
